export default __webpack_public_path__ + "assets/images/dc53dc2246240b1a9125f9bf8c1777f9.jpg";